module.exports = __webpack_public_path__ + "static/img/qiyelogo.4fcdad5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/qiyelogo.png
// module id = mUZq
// module chunks = 0